import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Inbox, TriangleAlert } from 'lucide-react';

export function LoadingState({ label }: { label?: string }) {
  const { t } = useTranslation();
  return (
    <div className="grid place-items-center py-16 text-sm text-ink-muted">
      {label ?? t('common.loading')}
    </div>
  );
}

export function EmptyState({ title, hint, action }: { title: string; hint?: string; action?: ReactNode }) {
  return (
    <div className="grid place-items-center gap-2 py-16 text-center">
      <Inbox className="h-8 w-8 text-line-strong" />
      <p className="text-sm font-medium">{title}</p>
      {hint && <p className="max-w-sm text-sm text-ink-muted">{hint}</p>}
      {action}
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="grid place-items-center gap-2 py-16 text-center">
      <TriangleAlert className="h-8 w-8 text-amber-500" />
      <p className="text-sm">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="text-sm text-accent underline">
          {t('common.tryAgain')}
        </button>
      )}
    </div>
  );
}
